import { render, staticRenderFns } from "./selectArea.vue?vue&type=template&id=46130670&scoped=true&"
import script from "./selectArea.vue?vue&type=script&lang=js&"
export * from "./selectArea.vue?vue&type=script&lang=js&"
import style0 from "./selectArea.vue?vue&type=style&index=0&id=46130670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46130670",
  null
  
)

export default component.exports